/**
 * ScrollToTop — restore natural top-of-page on route change.
 *
 *   • Every `pathname` change scrolls to (0, 0).
 *   • If the URL includes a hash (e.g. `/#section-compass`), we scroll to that
 *     anchor instead — preserves in-page jumps.
 *   • Uses `instant` behaviour (not smooth) so it feels like a real page load,
 *     not an animated glide.
 *
 * Wired into <BrowserRouter> in App.js so it applies globally.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Defer one frame so the destination section has mounted.
      const id = hash.replace(/^#/, "");
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "instant", block: "start" });
        } else {
          window.scrollTo(0, 0);
        }
      });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
